<template>
  <div :class="classes">pt-gene-report-apply-list</div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-gene-report-apply-list'

export default {
  name: 'pt-gene-report-apply-list',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
